import { variantMatchesLastWarehouse } from './behavioralContext.utils';

/**
 * Resolves the sidebar cart state for a product-page add-to-cart action.
 * Returns a partial sidebarCartData object with the modal flags set correctly.
 */
export const resolveProductPageCartState = ({
    dataSet,
    lastWarehouseAdded,
    acceptedTermUse,
    acceptedExamsUseTerms,
}) => {
    const hasMatchingWarehouse = variantMatchesLastWarehouse(
        dataSet.newProductData.productData.variants,
        lastWarehouseAdded
    );

    const hasAcceptedTerms   = acceptedTermUse || acceptedExamsUseTerms;
    const openSameWarehouse  = hasMatchingWarehouse && hasAcceptedTerms;

    return {
        ...dataSet,
        isSameWarehouseModalOpen: openSameWarehouse,
        isOpen:                   !openSameWarehouse,
    };
};

/**
 * Determines whether the same-warehouse flow should be triggered.
 */
export const shouldTriggerWarehouseFlow = ({ dataSet, lastWarehouseAdded, qtyItems }) =>
    !dataSet?.modalBypass &&
    Object.keys(lastWarehouseAdded).length > 0 &&
    qtyItems > 0 &&
    (dataSet?.isOpen || dataSet?.url);

/**
 * Builds the next sidebarCartData state for a simple (non-dataset) update.
 */
export const buildSimpleCartUpdate = (prevState, target, state) => ({
    ...prevState,
    [target]: typeof state !== 'undefined' ? state : prevState[target],
    // Clears transient product data when the cart is closed
    ...((target === 'isOpen' && !state) && { newProductData: {} }),
});
